import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ui-show-map-items-button',
    templateUrl: './show-map-items-button.component.html',
    styleUrls: ['./show-map-items-button.component.scss'],
    standalone: false,
})
export class ShowMapItemsButtonComponent {
}
